export enum PRODUCT_CODE {
  FIRST_APPOINTMENT_OFFLINE_LONG = 'cannabis.appointment.firstAppointment.offline.long',
  FIRST_APPOINTMENT_OFFLINE_MISSED_LONG = 'cannabis.appointment.firstAppointment.offline.missed.long',
  FIRST_APPOINTMENT_OFFLINE_MISSED_SHORT = 'cannabis.appointment.firstAppointment.offline.missed.short',
  FIRST_APPOINTMENT_OFFLINE_SHORT = 'cannabis.appointment.firstAppointment.offline.short',
  FIRST_APPOINTMENT_ONLINE_LONG = 'cannabis.appointment.firstAppointment.online.long',
  FIRST_APPOINTMENT_ONLINE_MISSED_LONG = 'cannabis.appointment.firstAppointment.online.missed.long',
  FIRST_APPOINTMENT_ONLINE_MISSED_SHORT = 'cannabis.appointment.firstAppointment.online.missed.short',
  FIRST_APPOINTMENT_ONLINE_SHORT = 'cannabis.appointment.firstAppointment.online.short',
  FOLLOW_UP_APPOINTMENT_OFFLINE = 'cannabis.appointment.followUpAppointment.offline',
  FOLLOW_UP_APPOINTMENT_OFFLINE_MISSED = 'cannabis.appointment.followUpAppointment.offline.missed',
  FOLLOW_UP_APPOINTMENT_ONLINE = 'cannabis.appointment.followUpAppointment.online',
  FOLLOW_UP_APPOINTMENT_ONLINE_MISSED = 'cannabis.appointment.followUpAppointment.online.missed',
  PRESCRIPTION_ONLINE = 'cannabis.prescription.online',
  DOCUMENT_MEDICAL_CERTIFICATE = 'document.medicalCertificate',
  DOCUMENT_MEDICAL_REPORT = 'document.medicalReport',
  DOCUMENT_SCHENGEN_CERTIFICATE = 'document.schengenCertificate',
  DOCUMENT_VEHICLE_CERTIFICATE = 'document.vehicleCertificate',
  RESERVATION_FIRST_APPOINTMENT_OFFLINE_LONG = 'reservation.cannabis.appointment.firstAppointment.offline.long',
  RESERVATION_FIRST_APPOINTMENT_OFFLINE_SHORT = 'reservation.cannabis.appointment.firstAppointment.offline.short',
  RESERVATION_FIRST_APPOINTMENT_ONLINE_LONG = 'reservation.cannabis.appointment.firstAppointment.online.long',
  RESERVATION_FIRST_APPOINTMENT_ONLINE_SHORT = 'reservation.cannabis.appointment.firstAppointment.online.short',
  RESERVATION_FOLLOW_UP_APPOINTMENT_OFFLINE = 'reservation.cannabis.appointment.followUpAppointment.offline',
  RESERVATION_FOLLOW_UP_APPOINTMENT_ONLINE = 'reservation.cannabis.appointment.followUpAppointment.online',
  RESERVATION_PRESCRIPTION_ONLINE = 'reservation.cannabis.prescription.online',
  RESERVATION_DOCUMENT_ID_CARD = 'reservation.document.idCard',
  RESERVATION_DOCUMENT_MEDICAL_CERTIFICATE = 'reservation.document.medicalCertificate',
  RESERVATION_DOCUMENT_MEDICAL_REPORT = 'reservation.document.medicalReport',
  RESERVATION_DOCUMENT_SCHENGEN_CERTIFICATE = 'reservation.document.schengenCertificate',
  RESERVATION_DOCUMENT_VEHICLE_CERTIFICATE = 'reservation.document.vehicleCertificate',
}
